import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { customThemeWithHeaders } from "@/pages/adjustments/manager/components/table/AdjustmentsManagerTable";
import { GridApi } from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { RejectedBillet } from "../models/RejectedBillet";
import { useTableData } from "./hooks/useTableData";

interface Props {
	rows: RejectedBillet[];
	isLoading: boolean;
	onGridReady: (api: GridApi<RejectedBillet>) => void;
}

export const RejectedManagerTable = ({
	rows,
	isLoading,
	onGridReady,
}: Props) => {
	const { columnDefs } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	return (
		<AgGridReact<RejectedBillet>
			loading={isLoading}
			rowData={rows}
			columnDefs={columnDefs}
			defaultColDef={defaultColDef}
			rowHeight={34}
			headerHeight={34}
			animateRows
			suppressContextMenu
			loadingOverlayComponent={CenteredLazyLoading}
			rowSelection="single"
			onGridReady={(params) => onGridReady(params.api)}
			getRowId={(params) => String(params.data.BilletId)}
			gridOptions={{
				rowSelection: {
					mode: "singleRow",
					checkboxes: false,
					enableClickSelection: true,
				},
				theme: customThemeWithHeaders,
			}}
		/>
	);
};
